module.exports = __webpack_public_path__ + "img/invitation-get-stamp@3x.c5a1edd6.png";